import useWindowDimensions from "@/components/Hooks/WindowDimension";
import { Specialty } from "@/graphql/graphql";
import { useAppDispatch } from "@/redux/hooks";
import { selectHomepage, setOpenModal } from "@/redux/state/homepage";
import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import {
  Button, Container,
  Modal,
  ModalFooter, Row
} from "reactstrap";
import SpecialtyCard from "../../Cards/SpecialtyCard";

const pickService_t_prefix = "pages.homePage.pickService";
interface SpecialtyModalProps {
  specialties: Specialty[]
}
const SpecialtyModal: React.FC<SpecialtyModalProps> = ({ specialties }) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { openModals } = useSelector(selectHomepage);
  const { specialty } = openModals;
  const { width } = useWindowDimensions()

  const isMobile = width < 991

  const toggleSpecialtyModal = (isOpen: boolean) =>
    dispatch(setOpenModal({ modal: "specialty", isOpen }));

  return (
    <>
      <Modal
        isOpen={specialty && isMobile}
        toggle={() => toggleSpecialtyModal(false)}
        className="el-modal"
      >
        <div className="modal-header justify-content-center">
          <button
            aria-hidden={true}
            className="close"
            onClick={() => toggleSpecialtyModal(false)}
            type="button"
          >
            <i className="now-ui-icons ui-1_simple-remove"></i>
          </button>
          <h4 className="title title-up">
            {t(`${pickService_t_prefix}.specialties`)}
          </h4>
        </div>
        <div className="modal-body">
          <Container>
            <Row xs="1" sm="1" md="3">
              {specialties &&
                specialties.map((specialty, index) => (
                  <SpecialtyCard key={index} specialty={specialty} />
                ))}
            </Row>
          </Container>
        </div>
        <ModalFooter>
          <Button
            color="danger"
            onClick={() => toggleSpecialtyModal(false)}
            style={{ margin: "0 auto" }}
          >
            {t(`${pickService_t_prefix}.close`)}
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default SpecialtyModal;
